export const formatPlanNumber = (num) => {
  if (num === 4) return "3A";
  if (num === 13) return "12A";
  if (num === 14) return "12B";

  if (num < 10) return `0${num}`;

  return String(num);
};

export const formatFloorLabel = (floorIndex) => {
  if (floorIndex === 0) return "Trệt";
  if (floorIndex === 4) return "3A";
  if (floorIndex === 13) return "12A";
  if (floorIndex === 14) return "12B";
  return floorIndex;
};

const FILTER_KEYS = ["agentId", "projectId", "areaId", "openSaleId"];

export const filtersToSearchParams = (filters) => {
  const params = {};

  for (const key of FILTER_KEYS) {
    if (filters[key] != null) params[key] = String(filters[key]);
  }

  return params;
};

// Trả về null nếu URL chưa có filter (chưa chọn dự án)
export const searchParamsToFilters = (searchParams) => {
  if (!searchParams.get("projectId")) return null;

  const result = {};

  for (const key of FILTER_KEYS) {
    const value = searchParams.get(key);
    if (!value) result[key] = null;
    else result[key] = /^-?\d+$/.test(value) ? Number(value) : value;
  }

  return result;
};

export const normalizeParams = (obj) => {
  const result = {};

  for (const [key, value] of Object.entries(obj)) {
    result[key] = value === "" || value === "null" || value == null ? null : value;
  }

  return result;
};
